import React from 'react';
import { motion } from 'framer-motion';
import Card from '../components/common/Card';
import Footer from '../components/common/Footer';

const Terms: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gray-50 py-8"
    >
      <div className="max-w-4xl mx-auto px-4">
      <Card className="p-8">
        <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-100 mb-4">Terms of Service</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-8">Effective Date: May 11, 2025</p>
        
        <div className="prose dark:prose-invert max-w-none">
          <p className="lead">
            These Terms of Service ("Terms") govern your use of VoiceVision. By using our service,
            you agree to be bound by these Terms.
          </p>
          
          <h2 className="text-xl font-semibold mt-8 mb-4">1. Use of Service</h2>
          <ul>
            <li>You must be 13 or older to use VoiceVision.</li>
            <li>You are responsible for any activity under your account.</li>
            <li>You agree not to misuse the service (e.g., reverse engineer, abuse usage limits, or engage in prohibited behavior).</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">2. Subscription and Billing</h2>
          <ul>
            <li>VoiceVision offers free and paid subscription plans.</li>
            <li>Billing is handled via Stripe. You are responsible for maintaining a valid payment method.</li>
            <li>We reserve the right to change pricing with prior notice.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">3. BYOK (Bring Your Own Key)</h2>
          <p>
            If you provide your own OpenAI API key, you accept responsibility for any usage charges
            incurred by OpenAI directly.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">4. Termination</h2>
          <ul>
            <li>You may delete your account at any time.</li>
            <li>We reserve the right to suspend or terminate accounts that violate these Terms.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">5. Limitation of Liability</h2>
          <p>
            VoiceVision is provided "as-is" without warranty. We are not liable for damages or loss
            resulting from your use of the app.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">6. Changes to These Terms</h2>
          <p>
            We may update these Terms periodically. Continued use of the service means you accept
            the changes.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">7. Contact</h2>
          <p>
            If you have questions about these Terms, please contact us at support@voicevision.app
          </p>
        </div>
      </Card>
      
      <Footer />
      </div>
    </motion.div>
  );
};

export default Terms;